// extracted by mini-css-extract-plugin
module.exports = {"rotation":"TecnologieSection_rotation__pFgc3"};